/**
 * Re-export DatePicker from the prebuilt bundle to avoid webpack
 * "Critical dependency" warnings from the ESM build's dynamic date-fns-tz require.
 */
import DatePicker from 'react-datepicker/dist/react-datepicker.min.js';
import 'react-datepicker/dist/react-datepicker.css';

export default DatePicker;
